<template>
  <q-dialog v-model="dialog" persistent transition-show="scale" transition-hide="scale">
    <q-card style="width: 600px; max-width: 95vw;" class="rounded-borders">
      <!-- Encabezado -->
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-sm">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon :name="editMode ? 'edit' : 'add_circle'" class="q-mr-xs" />
          {{ editMode ? "Editar Licencia" : "Agregar Nueva Licencia" }}
        </div>
        <q-btn icon="close" flat round dense v-close-popup @click="$emit('close')" />
      </q-card-section>

      <!-- Cuerpo del Formulario -->
      <q-card-section class="q-pa-md">
        <q-form ref="form" @submit.prevent="save" class="q-gutter-y-sm">
          <div class="row q-col-gutter-sm">
            <!-- RUC -->
            <div class="col-12 col-sm-6">
              <q-input
                v-model="localForm.ruc"
                label="RUC *"
                outlined
                dense
                :disable="editMode"
                :rules="[val => !!val || 'RUC es requerido', val => /^[0-9]{10,13}$/.test(val) || 'RUC debe ser de 10-13 dígitos']"
              />
            </div>
            <!-- Razón Social -->
            <div class="col-12 col-sm-6">
              <q-input
                v-model="localForm.company_name"
                label="Razón Social *"
                outlined
                dense
                :rules="[val => !!val || 'Razón Social es requerida']"
              />
            </div>
          </div>

          <!-- Nombre de Contacto -->
          <q-input
            v-model="localForm.name"
            label="Nombre de Contacto"
            outlined
            dense
          />

          <div class="row q-col-gutter-sm">
            <!-- Giro de la Empresa -->
            <div class="col-12 col-sm-6">
              <q-input
                v-model="localForm.business_type"
                label="Giro de la Empresa"
                outlined
                dense
              />
            </div>
            <!-- Número de Empleados -->
            <div class="col-12 col-sm-6">
              <q-input
                v-model.number="localForm.employee_count"
                type="number"
                label="Número de Empleados"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row q-col-gutter-sm">
            <!-- Celular -->
            <div class="col-12 col-sm-6">
              <q-input
                v-model="localForm.celular"
                label="Celular"
                outlined
                dense
              />
            </div>
            <!-- Correo Electrónico -->
            <div class="col-12 col-sm-6">
              <q-input
                v-model="localForm.correo_electronico"
                label="Correo Electrónico"
                outlined
                dense
                :rules="[val => !val || /.+@.+\..+/.test(val) || 'Correo inválido']"
              />
            </div>
          </div>

          <!-- Clave de Licencia con Generador -->
          <q-input
            v-model="localForm.license_key"
            label="Clave de Licencia *"
            outlined
            dense
            :disable="editMode"
            hint="Formato: XXXXX-XXXXX-XXXXX-XXXXX"
            :rules="[val => !!val || 'Clave requerida', val => /^[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}$/.test(val) || 'Formato inválido']"
          >
            <template v-slot:append>
              <q-btn flat round icon="refresh" color="primary" @click="generateLicense">
                <q-tooltip>Generar Clave Aleatoria</q-tooltip>
              </q-btn>
            </template>
          </q-input>

          <div class="row q-col-gutter-sm">
            <!-- Fecha de Expiración -->
            <div class="col-12 col-sm-6">
              <q-input
                v-model="localForm.expiry_date"
                type="date"
                label="Fecha Fin de Soporte *"
                outlined
                dense
                stack-label
                :rules="[val => !!val || 'Fecha requerida']"
              />
            </div>
            <!-- Tipo de Licencia -->
            <div class="col-12 col-sm-6">
              <q-select
                v-model="localForm.tipo_licencia"
                :options="['CONTABLE', 'COMERCIAL', 'PLANILLA', 'FULL', 'DEMO']"
                label="Tipo de Licencia *"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row q-col-gutter-sm items-center">
            <!-- Estado -->
            <div class="col-12 col-sm-6">
              <q-select
                v-model="localForm.estado"
                :options="['activo', 'baja']"
                label="Estado *"
                outlined
                dense
              />
            </div>
            <!-- Activa -->
            <div class="col-12 col-sm-6">
              <q-checkbox
                v-model="localForm.is_active"
                label="Licencia Habilitada"
                color="primary"
              />
            </div>
          </div>

          <!-- Botones de Acción -->
          <div class="row justify-end q-gutter-sm q-pt-md">
            <q-btn label="Cancelar" flat color="negative" v-close-popup @click="$emit('close')" />
            <q-btn label="Guardar Licencia" type="submit" color="primary" unelevated class="text-weight-bold" />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    editMode: Boolean,
    formData: Object,
  },
  data() {
    return {
      localForm: {
        tipo_licencia: "CONTABLE",
        ...this.formData,
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    formData(newVal) {
      this.localForm = {
        tipo_licencia: "CONTABLE",
        ...newVal,
      };
    },
  },
  methods: {
    generateLicense() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let key = "";
      for (let i = 0; i < 20; i++) {
        if (i > 0 && i % 5 === 0) key += "-";
        key += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.localForm.license_key = key;
    },
    save() {
      this.$emit("save", this.localForm);
    },
  },
};
</script>
